import React,{useEffect} from 'react';

const Wall = ({ width, height, depth, position, color = '#E5E4E2',setLegendData }) => {
    useEffect(() => {
        setLegendData((prevState) => {
            const alreadyExists = prevState.some(item => item.name === "Wall");
            if (alreadyExists) return prevState;
            return [...prevState, { name: "Wall", color: "#E5E4E2" }];
          });
    },[])
    return (
        <mesh position={position}>
            <boxGeometry args={[width, height, depth]} />
            <meshStandardMaterial color={color} />
        </mesh>
    );
};

export default Wall;
